// extracted by mini-css-extract-plugin
export default {"card":"ChargePointConnectorList_card__zCCq4"};